import smoothscroll from 'smoothscroll-polyfill';
import 'whatwg-fetch';

// полифилы вставляем внутрь функции
export const enablePolyfills = () => {
  smoothscroll.polyfill();
};
